import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.user.manageuser;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    GET_USER_ASYNC: `${uid}.getUserAsync`,
    GET_USER_SUCCESS: `${uid}.getUserSuccess`,
    GET_USER_FAILURE: `${uid}.getUserFailure`,
    DELETE_USER_ASYNC: `${uid}.deleteUserAsync`,
    DELETE_USER_SUCCESS: `${uid}.deleteUserSuccess`,
    DELETE_USER_FAILURE: `${uid}.deleteUserFailure`,
    DELETE_USERS_ASYNC: `${uid}.deleteUsersAsync`,
    DELETE_USERS_SUCCESS: `${uid}.deleteUsersSuccess`,
    DELETE_USERS_FAILURE: `${uid}.deleteUsersFailure`,
    RECOVER_USER_ASYNC: `${uid}.recoverUserAsync`,
    RECOVER_USER_SUCCESS: `${uid}.recoverUserSuccess`,
    RECOVER_USER_FAILURE: `${uid}.recoverUserFailure`,
    SAVE_USER_ASYNC: `${uid}.saveUserAsync`,
    SAVE_USER_SUCCESS: `${uid}.saveUserSuccess`,
    SAVE_USER_FAILURE: `${uid}.saveUserFailure`,
    CREATE_USER: `${uid}.createUser`,
    UPDATE_FILTER_BY: `${uid}.updateFilterBy`,
    SET_EXTEND_VIP_MODAL: `${uid}.setExtendVipModal`,

    EXTEND_VIP_TIME_ASYNC: `${uid}.extendVipTimeAsync`,
    EXTEND_VIP_TIME_SUCCESS: `${uid}.extendVipTimeSuccess`,
    EXTEND_VIP_TIME_FAILURE: `${uid}.extendVipTimeFailure`,

    GET_ALL_COUNTRY_CODE_ASYNC:`${uid}.getAllCountryCodeAsync`,
    GET_ALL_COUNTRY_CODE_SUCCESS:`${uid}.getAllCountryCodeSuccess`,
    GET_ALL_COUNTRY_CODE_FAILURE:`${uid}.getAllCountryCodeFailure`,

    LOGIN_OTHER_USER_ASYNC: `${uid}.loginOtherUserAsync`,
    LOGIN_OTHER_USER_SUCCESS: `${uid}.loginOtherUserSuccess`,
    LOGIN_OTHER_USER_FAILURE: `${uid}.loginOtherUserFailure`,

};

export { ActionTypes };
